import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const StyledContentPageContainer = styled.div`
    padding-bottom: ${getPurpurSpacing('800')};

    ${purpurMedia('lg')`
        padding-bottom: ${getPurpurSpacing('1000')};
    `};
`;
